// base.js定义全局函数
exports.install = function (Vue, options) {
	
	// 全局变量：百度统计数据请求地址
	Vue.prototype.globalBaiduUrl = "http://www.fortune-sun.com:9091/baidu/getbaidu";
  // 将中国标准时间格式化  年/月/日
	Vue.prototype.formatDate = function(date){
		var year = date.getFullYear();
		var month = date.getMonth() + 1;
		var day = date.getDate();
		return year + "" + formatTen(month) + "" + formatTen(day); 
	}
	
	//	简繁图片的更换
	Vue.prototype.imgReplace = function(date){
		var lang = localStorage.getItem('language');
		
		
		if(lang=="tc"){
			$('.JFImg').each(function(){
				if($(this).attr('imgZH') != 'TC'){
					var imgfan = $(this).attr('src').split(".");
					var imgSrc = imgfan.join("fan.")
					$(this).attr('src',imgSrc);
					$(this).attr('imgZH','TC');
				}
			})
		}else if(lang=="zh"){
			$('.JFImg').each(function(){
				if($(this).attr('imgZH') != 'ZH'){
					var imgfan = $(this).attr('src').split("fan.");
					var imgSrc = imgfan.join(".")
					$(this).attr('src',imgSrc);
					$(this).attr('imgZH','ZH');
				}
			})
		}else if(lang == "en"){
			$('.ENImg').each(function(){
				if($(this).attr('imgZH') != 'EN'){
					var imgfan = $(this).attr('src').split(".");
					var imgSrc = imgfan.join("ENG.");
					$(this).attr('src',imgSrc);
					$(this).attr('imgZH','EN');
				}
			})
		}
		
	}
	Vue.prototype.indMO = '0';
//	// 二级菜单选中样式
//	Vue.prototype.changeBgcGlobal = function(index,e){
//		$('.nav-tabs').find('li').removeClass('secondMenuActive');
//		this.num = index;
//		$('.nav-tabs').find('li').eq(index).addClass('secondMenuActive');
////		var nb = e.target.getAttribute("id");
////		this.indMO = nb;
//}

};


// WEBPACK FOOTER //
// ./src/components/common/global.js